<template>
    <validation-observer #default="{ invalid }" ref="observer">
        <span class="display-none">{{ invalid }}</span>
        <b-form class="mt-4">
            <PlanInputContent
                title="G. Etape și ținte pentru dezvoltarea activităților din cadrul proiectului"
                warn="Această secțiune trebuie să identifice etapele principale, începutul și sfârșitul programat al acestora (a se vedea diagrama GANTT)."
            >
                <template v-slot:body>
                    <div class="textarea">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-textarea
                                v-model="form.steps"
                                rows="4"
                                max-rows="20"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                                @input="$emit('unsavedChanges', !!form.steps.length)"
                            ></b-form-textarea>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                        <b-icon-pencil-square font-scale="1.2"></b-icon-pencil-square>
                    </div>
                </template>
            </PlanInputContent>
            <hr class="mt-5">
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                :disabled="invalid"
                @change="completeForm()"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </b-form>
    </validation-observer>
</template>

<script>
    import { BForm, BFormInput, BFormCheckbox, BFormTextarea, BIconPencilSquare, BIconCheckCircleFill, BTable, BIconXCircleFill} from "bootstrap-vue";
    import PlanInputContent from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/PlanInputContent'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormInput,
            PlanInputContent,
            BFormCheckbox,
            BFormTextarea,
            BIconPencilSquare,
            BIconCheckCircleFill,
            BTable,
            BIconXCircleFill,
            ValidationProvider, ValidationObserver
        },
        props: {
            etapeTinte: null,
        },
        data() {
            return {
                completed: false,
                form: {
                    steps: null,
                },
                companyName: '',
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch: {
            checks: {
                handler: function() {
                    this.completed = this.checks.planDeAfaceriEtapeTinte;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            etapeTinte: {
                handler () {
                    if(this.etapeTinte !== null){
                        this.form.steps = this.etapeTinte.business_plan_stages_targets
                    }
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            this.companyName = JSON.parse(localStorage.getItem('currentM3Company')).name
            if(!this.form.steps){
                this.form.steps = 'Proiectul de investitii în activități productive pentru '+this.companyName+' este structurat in ' +
                    'activitati si subactivitati specifice intr-o perioada maxima pana cel mai tarziu la decembrie 2023.\n' +
                    'Activitatile ce urmeaza a fi implementate in cadrul proiectului:\n'

                if(this.allData && this.allData.m3_project && this.allData.m3_project.activities && this.allData.m3_project.activities.activities.length){

                    this.form.steps = this.form.steps + '\n';

                    this.allData.m3_project.activities.activities.forEach( activity => {
                        this.form.steps = this.form.steps + 'Activitatea ' + activity.number + '. - ' + activity.title + '\n'
                        activity.childrens.forEach( child => {
                            this.form.steps = this.form.steps + activity.number + '.' + child.number + '. - ' + child.title + '\n'
                        })
                        this.form.steps += '\n'
                    })

                }
                this.form.steps += 'Activitatile ce urmeaza a fi implementate in cadrul proiectului sunt descrise pe larg în cererea de finanțare.'
            }
        },
        methods: {
            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else{
                        this.formSend = {
                            business_plan_stages_targets: {
                                business_plan_stages_targets: this.form.steps,
                                checked: this.completed
                            }
                        }
                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.formSend)
                            .then((firstResponse) => {
                                this.$toast.success(firstResponse.data)
                            }).catch((xhr) => {
                                if (xhr.status === 422) {
                                    this.errors.record(xhr.responseJSON.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                            });
                    }
                })
                if(this.checks.planDeAfaceriEtapeTinte !== this.completed)
                    this.$store.dispatch('checks/updateChecks', { name: 'planDeAfaceriEtapeTinte', value: this.completed })
            },
        }
    }
</script>

<style scoped>
.textarea{
    position: relative;
}
.textarea >>> textarea:read-only{
    background: #e5fffb;
}
.textarea >>> textarea{
    border: 2px solid #9da2b0;
    background: #f8f9f9;
    color: #515679;
}
.textarea >>> textarea:focus{
    box-shadow: 0 0 0 0.2rem #cdfaee;
}
.textarea svg{
    position: absolute;
    top: 10px;
    right: 10px;
    color: #9da2b0;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
</style>
